
function SmartInputMockup() {
  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg p-6 space-y-4">
      {/* Input field */}
      <div className="bg-warm-bg-base border border-warm-border rounded-lg px-4 py-3 flex items-center">
        <span className="text-sm text-warm-text-primary">
          Meeting with John tomorrow at 2pm
        </span>
        <span
          className="w-0.5 h-5 bg-warm-blue ml-0.5"
          style={{ animation: "landing-typing-cursor 1s ease-in-out infinite" }}
        />
      </div>

      {/* Parsed highlights */}
      <div className="space-y-3 pl-2">
        <div className="flex items-center gap-3">
          <div className="w-1 h-8 rounded-full bg-warm-blue" />
          <div>
            <span className="text-[10px] uppercase tracking-wider text-warm-text-tertiary font-medium">
              Title
            </span>
            <p className="text-sm font-medium text-warm-text-primary">Meeting with John</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-1 h-8 rounded-full" style={{ backgroundColor: "var(--color-accent-emerald)" }} />
          <div>
            <span className="text-[10px] uppercase tracking-wider text-warm-text-tertiary font-medium">
              Date
            </span>
            <p className="text-sm font-medium text-warm-text-primary">
              Tomorrow &rarr; <span className="text-warm-blue">Mar 16, 2026</span>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-1 h-8 rounded-full" style={{ backgroundColor: "var(--color-accent-violet)" }} />
          <div>
            <span className="text-[10px] uppercase tracking-wider text-warm-text-tertiary font-medium">
              Time
            </span>
            <p className="text-sm font-medium text-warm-text-primary">
              2pm &rarr; <span className="text-warm-blue">2:00 PM</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmartInputMockup;
